<template>
  <div class="highcharts-wrapper">
    <highcharts
      v-if="options"
      ref="chartComponent"
      :options="options"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

defineProps<{
  options?: Record<string, unknown> | null;
}>();

const chartComponent = ref<{
  chart?: {
    series: { setVisible: (visible: boolean, redraw: boolean) => void }[];
    redraw: () => void;
  };
} | null>(null);

defineExpose({
  get chart() {
    return chartComponent.value?.chart;
  },
});
</script>

<style scoped>
.highcharts-wrapper {
  width: 100%;
}
</style>
